<template>
  <div>
    <UnvocalizedScan></UnvocalizedScan>
    <ResultUpdates></ResultUpdates>
  </div>
</template>

<script>
import ResultUpdates from '@/components/ResultUpdates'
import UnvocalizedScan from '@/components/UnvocalizedScan.vue'
export default {
  name: 'Unvocalized',
  components: {
    UnvocalizedScan,
    ResultUpdates,
  },
  computed: {
    mobile () {
      return this.$mq === 'xs'
    }
  }  
}
</script>